export const getProfileImageForAddress = (address?: string | null) => {
  const defaultImage = '/images/profile-pic/profile-pic-1.svg'
  if (!address) return defaultImage
  const normalized = address.replace(/^0x/i, '')
  if (!normalized) return defaultImage
  const parsed = parseInt(normalized.slice(0, 8), 16)
  if (Number.isNaN(parsed)) return defaultImage
  const index = (parsed % 12) + 1
  return `/images/profile-pic/profile-pic-${index}.svg`
}
